/**
 * Solana chains on which the Sablier Protocol is deployed, exported individually and as a `chains` object.
 *
 * For further documentation, visit:
 * @see https://docs.sablier.com/concepts/chains
 */
export * as chains from "./chains.js";
export * from "./chains.js";
